/**
 * CSS class name used to prevent row hover highlighting when a child element is hovered.
 *
 * Apply this to the row's `sx` prop to highlight it on hover, and add the class to any
 * child elements (e.g. buttons) that should suppress the row highlight when they are hovered.
 *
 * @example
 * // Highlight the row on hover, but not when a child with this class is hovered
 * sx={{
 *   [`&:hover:not(:has(.${stopRowHighlightClassName}:hover))`]: {
 *     backgroundColor: palette.background.tertiary,
 *   },
 * }}
 *
 * // Suppress row highlight when this button is hovered
 * <Button className={stopRowHighlightClassName} />
 */
const stopRowHighlightClassName = 'no-row-highlight';

export { stopRowHighlightClassName };
